export default {
  namespaced: true,
  modules: {
    'mdc-store': require('./mdc-store').default
  }
}
